<template>
    <svg width="20.879028px" height="11.939514px" viewBox="0 0 20.879028 11.939514" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
        <g id="iconChevronDown" transform="translate(-5.560547 -10.560486)">
            <path d="M16 22.5C15.616 22.5 15.232 22.354 14.939 22.061L6 13.121C5.414 12.535 5.414 11.586 6 11C6.586 10.414 7.535 10.414 8.121 11L16 18.879L23.879 11C24.465 10.414 25.414 10.414 26 11C26.586 11.586 26.586 12.535 26 13.121L17.061 22.061C16.768 22.354 16.384 22.5 16 22.5" id="ChevronDown" fill-rule="evenodd" stroke="none" />
        </g>
    </svg>
</template>